import { Modal } from "antd";
import SearchList from "./SearchList";

function SearchModal({isSearchVisble,setIsSearchVisble,data}) {
  
  
  const handleCancel = () => {
    setIsSearchVisble(false);
  };

  return (
    <Modal
      title="Search Product"
      open={isSearchVisble}
      onCancel={handleCancel}
      footer={null}
    >
      <SearchList
        data={data}
        setIsSearchVisble={setIsSearchVisble}
        isSearchVisble = {isSearchVisble}
        oldPhone={false}
      />
    </Modal>
  );
}

export default SearchModal;
